export function getWindowYPosition(window: Window): number {
  return window.pageYOffset || window.document.documentElement.scrollTop;
}
